import { render, staticRenderFns } from "./SideNavHeader.vue?vue&type=template&id=4bb79dc8&scoped=true"
import script from "./SideNavHeader.vue?vue&type=script&lang=js"
export * from "./SideNavHeader.vue?vue&type=script&lang=js"
import style0 from "./SideNavHeader.vue?vue&type=style&index=0&id=4bb79dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb79dc8",
  null
  
)

export default component.exports